import { isNaN } from "lodash";

export const convertStringToNumber = (scale: number = 2) => (value: string): null | number => {
    const decimals = value.match(/^\d+([,.](?<decimals>\d+))?$/)?.groups?.decimals?.length;

    if (decimals && decimals > scale) {
        value = value.substring(0, value.length - (decimals - scale));
    }
    const number = decimals ? parseFloat(value) : parseInt(value, 10);

    return isNaN(number) ? null : number;
}
